import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { forms as Forms } from '@breezeway/brzw-components';

import './form_control_input.scss';

const FormControlInput = ({
  additionalProps,
  id,
  input: { onChange, value },
  label,
  meta: { touched, error, warning },
  placeholder,
  required,
  shouldShowTextError,
  type,
  withoutAction,
}) => {
  const withError = touched && !_.isEmpty(error || warning);

  return (
    <div className="form-control-input__wrapper">
      <Forms.Input
        id={id}
        isRequired={required}
        labelText={label}
        onChange={onChange}
        placeholderText={placeholder}
        type={type}
        value={value}
        withError={withError}
        withoutAction={withoutAction}
        {...additionalProps}
      />
      {shouldShowTextError && withError && (
        <span className="form-control-input__error">{error}</span>
      )}
    </div>
  );
};

FormControlInput.propTypes = {
  additionalProps: PropTypes.shape({}),
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.string,
  meta: PropTypes.shape({}),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  shouldShowTextError: PropTypes.bool,
  type: PropTypes.string,
  withoutAction: PropTypes.bool,
};

FormControlInput.defaultProps = {
  type: 'text',
  withoutAction: false,
};

export default FormControlInput;
